import { IDataHandler } from '../IDataHandler';
import { TransactionTrackingEventName } from '../TrackingEvent';
import { TransactionDataSet } from '../DataSet/Transaction';

export const TransactionEventDataMap: {
    [key in TransactionTrackingEventName]: (keyof TransactionDataSet)[];
} = {
    [TransactionTrackingEventName.transaction]: [
        'transactionType',
        'tGameArea',
        'tActionType',
        'tLevelTypeContext',
        'tLevelContext',
        'transactionID',
        'productsSpent',
        'tTransactionCoins',
        'tTransactionBoosters',
        'tTransactionCoinWorth',
    ],
    [TransactionTrackingEventName.resource]: [
        'tChangerReceived',
        'tChangerUsed',
        'tRemoveOneReceived',
        'tRemoveOneUsed',
        'tMassRemoveReceived',
        'tMassRemoveUsed',
        'tJokerReceived',
        'tJokerUsed',
        'tCoinsReceived',
        'tCoinsUsed',
        'tLivesReceived',
        'tMapExtraCardsReceived',
        'tLevelExtraCardsReceived',
        'tLevelExtraCardsNumber',
        'transactionType',
        'tGameArea',
        'tActionType',
        'tLevelTypeContext',
        'tLevelContext',
        'transactionID',
        'tShopRewardCoins',
        'tCoinsLevelEnd',
        'tAdCoins',
        'tIAPCoins',
        'tFailFlowCoinsReceived',
        'tFailFlowCoinsUsed',
        'tStreakExtraCards',
        'tHelperCards',
    ],
};

export class TransactionDataHandler
    implements IDataHandler<TransactionDataSet> {
    public data: TransactionDataSet = new TransactionDataSet();

    public getEventData(
        eventName: TransactionTrackingEventName
    ): TransactionDataSet {
        const data = TransactionEventDataMap[eventName].reduce(
            (acc, key) => {
                acc[key] = this.data[key];
                return acc;
            },
            {} as TransactionDataSet
        );

        if (eventName !== TransactionTrackingEventName.transaction) {
            this.data = new TransactionDataSet();
        }

        return data;
    }
}
